import { TopicRepoModel } from '@shared/domain/topic/topic.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { configuration } from 'configuration';

export const topicRepositoryImplementation = {
  getTopics: async (
    countryCode: string,
    languageCode: string
  ): Promise<TopicRepoModel[]> => {
    const Topics = await httpClient.get<TopicRepoModel[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/topics`,
      {
        'Accept-Language': languageCode
      }
    );
    return Topics;
  },

  uploadTopicImgBackground: (
    topicId: number,
    countryCode: string,
    body: any
  ): Promise<string> => {
    return httpClient
      .post(
        `${configuration.api.baseUrl}/api/${countryCode}/topics/${topicId}/panoramic-image`,
        body,
        { 'Content-Type': 'image/jpeg' }
      )
      .then((res) => {
        const location = res.headers.get('location');
        console.log('response headers', res.headers);
        if (!location) {
          throw new Error('Expected location header to be present.', {
            cause: { response: res }
          });
        }
        return location;
      });
  },

  toggleEnableTopic: async (
    topicId: number,
    countryCode: string
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/topics/${topicId}/enabled`,
      {}
    );
  },

  updateTopic: async (
    countryCode: string,
    languageCode: string,
    data: TopicRepoModel
  ): Promise<void> => {
    await httpClient.put(
      `${configuration.api.baseUrl}/api/${countryCode}/topics/${data.id}`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  createTopic: async (
    countryCode: string,
    languageCode: string,
    data: TopicRepoModel
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/topics`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  deleteTopic: async (countryCode: string, topicId: number): Promise<void> => {
    await httpClient.delete(
      `${configuration.api.baseUrl}/api/${countryCode}/topics/${topicId}`
    );
  }
};
